import axios from 'axios';
import { serviceUserJwt } from './serviceConfig';
import { EventEmitter } from './events';
export async function getMessages() {
  let workQueueFilterResponse = [];
  let userId = JSON.parse(sessionStorage.getItem('userId'));
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/message?userId=' + userId;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }
  return workQueueFilterResponse;
}
export async function buowLockCheck(data) {
  let workQueueFilterResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/in_baskets/lock/' + data;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
    return (workQueueFilterResponse = ex.response);
  }
  return workQueueFilterResponse;
}
export async function buowLockLooper(data, flag) {
  let workQueueFilterResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/in_baskets/lock/' + data + `?isLocked=${flag}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
    return (workQueueFilterResponse = ex.response);
  }
  return workQueueFilterResponse;
}
export async function dismissMessage(url) {
  let workQueueFilterResponse = [];
  try {
    const baseUrl = window.env.REACT_APP_BACKEND_URL + '/buow_api/message/dismiss_message?' + url;
    await axios
      .patch(
        baseUrl,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            },
        }
      )
      .then((response) => {
        workQueueFilterResponse = response;
      });
  } catch (ex) {
    console.log('Error in dismissMessage ', ex.message);
  }
  return workQueueFilterResponse;
}
export async function getWorkgroups() {
  let workQueueFilterResponse1 = [];
  let userId = JSON.parse(sessionStorage.getItem('userId'));
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/get-user-workgroups?userId=' + userId;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
    return [];
  }
  return workQueueFilterResponse1;
}
export async function getWorkflowHistory(data) {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/buowauditlog/workflow?buowId=' + data;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
    return ex;
  }
  return workQueueFilterResponse1;
}
export async function getWorkgroupItemsByWorkgroupId(id, params) {
  let storedUser = JSON.parse(sessionStorage.getItem('user'));
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/get-in-basket/v2?workgroupId=' + id + params;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }
  return workQueueFilterResponse1;
}
export async function getWorkgroupItemsByUserId(param) {
  let workQueueFilterResponse1 = [];
let userId = JSON.parse(sessionStorage.getItem('userId'));
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/get-in-basket/v2?userId=' + userId + '&' + param;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
           
          },
        }
      )
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }
  return workQueueFilterResponse1;
}

let workgroupNameCache = null;

async function getWorkgroupNameMap() {
  if (workgroupNameCache) return workgroupNameCache;
  const response = await getWorkgroups();
  const list = Array.isArray(response?.data) ? response.data : [];
  const map = {};
  list.forEach((wg) => {
    const id = wg.workgroupId ?? wg.id;
    const name = wg.workgroupName ?? wg.workgroupDisplayName ?? wg.name;
    if (id && name) map[id] = name;
  });
  workgroupNameCache = map;
  return map;
}

function groupItemsByWorkgroup(items, nameMap) {
  const grouped = {};
  items.forEach((item) => {
    const key = nameMap[item.workgroupId] ?? item.workgroupId ?? 'Unknown';
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push({
      ...item,
      workgroupDisplayName: key,
    });
  });
  return grouped;
}

export async function getWorkgroupItems(params) {
  let workQueueFilterResponse1 = [];

  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/get-in-basket/v2?' + params;
    const response = await axios.post(
      url,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    workQueueFilterResponse1 = response;
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }

  if (Array.isArray(workQueueFilterResponse1?.data)) {
    const nameMap = await getWorkgroupNameMap();
    workQueueFilterResponse1 = {
      ...workQueueFilterResponse1,
      data: groupItemsByWorkgroup(workQueueFilterResponse1.data, nameMap),
    };
  }

  return workQueueFilterResponse1;
}

export async function getPages(param) {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + encodeURI('/buow_api/get-document/get-pages?documentId=' + param.documentId);
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getPages ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function getXmlFile(param) {
  let workQueueFilterResponse1 = [];
  let postRedaction = param?.postRedaction !== undefined ? param?.postRedaction : false;
  try {
    const url = window.env.REACT_APP_BACKEND_URL + encodeURI('/buow_api/get-document/xml?documentId=' + param.documentId + '&postRedaction=' + postRedaction);
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getPages ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function getDocuments(param) {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + encodeURI('/buow_api/get-document/v2?documentId=' + param.documentId);
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getDocuments ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function getHTMLDocuments(param) {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + encodeURI('/buow_api/get-document?documentId=' + param.documentId);
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getHTMLDocuments ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function getXMLValue(param) {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + encodeURI('/buow_api/get-document/isxml?documentId=' + param.documentId);
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getXmlValue ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function getBuowItems(param) {
  let workQueueFilterResponse1 = [];
  const buowDetails = JSON.parse(sessionStorage.getItem('redirectTo'));
  let buowType = param?.buow_type || buowDetails?.buowType;
  let buowName = param?.buow_name || buowDetails?.buowName;
  let userId = JSON.parse(sessionStorage.getItem('userId'));
  try {
    let url = window.env.REACT_APP_BACKEND_URL + '/buow_api/buows/get-buow?buowType=' + buowType + '&buowName=' + buowName + '&buowId=' + param.buow_id;
    if (window.localStorage.getItem('buow_relation') === 'W') {
      url += '&workgroupId=' + window.localStorage.getItem('buow_WorkgroupId');
    } else {
      url += '&userId=' + userId;
    }
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    workQueueFilterResponse1 = ex;
    console.log('Error in get getBuowItems ', ex.message);
  }
  return workQueueFilterResponse1;
}
export async function getThumbnailByBuowID(buowId) {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/get-pdf-thumbnail/v2';
    await axios
      .post(url, buowId, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getThumbnailByBuowID ', ex.message);
  }
  return workQueueFilterResponse1;
}
export async function uploadBuowFile(data, progressBarData) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/upload-file';
    await axios
      .post(url, data, progressBarData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      })
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
  }
  return uploadResponse;
}

export async function getFileData() {
  let workQueueFilterResponse1 = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/workqueues';
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getThumbnailByBuowID ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function getSystemConfigDetails(contextId, alwaysCall = false) {
  if (!contextId) return [];

  let getSystemConfigResponse = [];

  try {
    const url = `${window.env.REACT_APP_BACKEND_URL}/buow_api/systemconfiguration?contextId=${contextId}`;
    const system_config = JSON.parse(window.localStorage.getItem('system_config'));

    if (!system_config || alwaysCall) {
      const headers = {
        'Content-Type': 'application/json',
      };

      const token = sessionStorage.getItem('authorizationToken');
      const storedUser = JSON.parse(sessionStorage.getItem('user'));

      if (token) {
        headers['X-Authorization-Token'] = token;
      }

      if (storedUser?.access_token) {
        headers['Authorization'] = `Bearer ${storedUser.access_token}`;
      }

      if (storedUser?.profile?.preferred_username) {
        headers['Username'] = storedUser.profile.preferred_username;
      }

      if (storedUser?.profile?.email) {
        headers['Email'] = storedUser.profile.email;
      }

      const response = await axios.get(url, { headers });

      getSystemConfigResponse = response;
      window.localStorage.setItem('system_config', JSON.stringify(response.data));
      EventEmitter.emit('LocalStorageUpdated');
    }
  } catch (ex) {
    console.error('Error in getSystemConfigDetails:', ex.message);
  }

  return getSystemConfigResponse;
}

export async function getRedactionConfiguration(contextId) {
  if (!contextId) return [];

  let getRedactionConfigResponse = [];
  try {
    const url = `${window.env.REACT_APP_BACKEND_URL}/buow_api/redactionconfiguration?contextId=${contextId}`;
    const redaction_configuration = JSON.parse(window.localStorage.getItem('redaction_configuration'));

    if (!redaction_configuration) {
      const headers = {
        'Content-Type': 'application/json',
      };

      const token = sessionStorage.getItem('authorizationToken');
      const storedUser = JSON.parse(sessionStorage.getItem('user'));

      if (token) {
        headers['X-Authorization-Token'] = token;
      }

      if (storedUser?.access_token) {
        headers['Authorization'] = `Bearer ${storedUser.access_token}`;
      }

      if (storedUser?.profile?.preferred_username) {
        headers['Username'] = storedUser.profile.preferred_username;
      }

      if (storedUser?.profile?.email) {
        headers['Email'] = storedUser.profile.email;
      }

      const response = await axios.get(url, { headers });

      getRedactionConfigResponse = response;
      window.sessionStorage.setItem('redaction_configuration', JSON.stringify(response.data));
      EventEmitter.emit('LocalStorageUpdated');
    }
  } catch (ex) {
    console.error('Error in getRedactionConfigurationDetails:', ex.message);
  }

  return getRedactionConfigResponse;
}

export async function getRoutingStepsBuow(buowID) {
  let getSystemConfigResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/routingstep?buowId=${buowID}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getSystemConfigResponse = response;
      });
  } catch (ex) {
    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getSystemConfigResponse;
}

export async function putHTMLDocument(documentId, htmlBlob) {
  try {
    const url = window.env.REACT_APP_BACKEND_URL + encodeURI('/buow_api/get-document?documentId=' + documentId);

    const response = await axios.put(url, htmlBlob, {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    });

    return response;
  } catch (error) {
    console.error('Error in putHTMLDocument:', error.message);
    return null;
  }
}

export async function searchWorkgroups(text) {
  let getSystemConfigResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/workgroups/search/${text}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getSystemConfigResponse = response;
      });
  } catch (ex) {
    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getSystemConfigResponse;
}
export async function addNewRoutingTableEntryttoBuow(payload) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/routingstep/save';
    await axios
      .post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    uploadResponse = ex;
    console.log('Error', ex.message);
  }
  return uploadResponse;
}
export async function addNewNotestoBuow(data) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/note';
    await axios
      .post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
  }
  return uploadResponse;
}

export async function submitBUOW(data) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/routingstep/submit?userOrWorkgroupId=${data.workgroupId}&buowId=${data.buowId}&step=${data.step}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            },
        }
      )
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
    uploadResponse = null;
  }
  return uploadResponse;
}

export async function buowRejectReInitiate(data) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/routingstep/reinitiate?buowId=${data.buowId}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            },
        }
      )
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
    uploadResponse = null;
  }
  return uploadResponse;
}

export async function rejectBUOW(data) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/routingstep/reject?userOrWorkgroupId=${data.workgroupId}&buowId=${data.buowId}&step=${data.step}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            },
        }
      )
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
    uploadResponse = null;
  }
  return uploadResponse;
}

export async function getSentimentData(payload) {
  let getSystemConfigResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/sentiments?documentId=${payload.id}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getSystemConfigResponse = response;
      });
  } catch (ex) {
    getSystemConfigResponse.error = ex.response.data;
    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getSystemConfigResponse;
}
export async function failedSentimentCall(payload) {
  let getSystemConfigResponse = [];
  try {
    const url = `/buow_api/sentiments/emotion?documentId=${payload.id}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getSystemConfigResponse = response;
      });
  } catch (ex) {
    getSystemConfigResponse.error = ex.response.data;

    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getSystemConfigResponse;
}
export async function getPdfOcr(param) {
  let workQueueFilterResponse1 = [];
  try {
    const url = encodeURI(window.env.REACT_APP_BACKEND_URL + '/buow_api/get-document/get-pdf-ocr?documentId=' + param.documentId);

    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse1 = response;
      });
  } catch (ex) {
    console.log('Error in get getDocuments ', ex.message);
  }
  return workQueueFilterResponse1;
}

export async function addNewQuetion(data) {
  let uploadResponse = {};
  try {
    const url = 'https://u01tuuaph7.execute-api.us-east-1.amazonaws.com/PRODUCTION/ml-api-resources-qa';
    await axios
      .post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
    uploadResponse.error = ex;
  }
  return uploadResponse;
}

export async function addNewQuetionAlice(data) {
  let uploadResponse = {};
  try {
    const url = `http://3.143.141.252/brag_exec?query=${data.question}&domain=${data.contextName}`;
    await axios
      .get(
        url,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            },
        }
      )
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
    uploadResponse.error = ex;
  }
  return uploadResponse;
}

export async function searchBUOWByText(text) {
  let getSystemConfigResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/in_baskets/search-buow/${text}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getSystemConfigResponse = response;
      });
  } catch (ex) {
    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getSystemConfigResponse;
}

export async function oktaLogin(accessToken) {
  let getUserResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/security_api/security/validate`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getUserResponse = response;
      });
  } catch (ex) {
    if (ex.response.data.message === 'Access Denied: Your account is currently inactive.') {
      sessionStorage.clear();
      document.location = `/access-error`;
    }
    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getUserResponse;
}

export async function updateNextInBasket(data) {
  let UpdateResponse = [];
  const headers = {
    'Content-Type': 'application/json',
  };
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/buow_api/rulelogs/datavalue';

    const response = await axios.put(url, data, { headers });

    UpdateResponse = response;
  } catch (ex) {
    console.error('Error in updateNextInBasket()', ex.message);
    UpdateResponse.error = ex.response.data;
  }
  return UpdateResponse;
}

export async function searchUsers(text) {
  let getSystemConfigResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/security_api/user/search/${text}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getSystemConfigResponse = response;
      });
  } catch (ex) {
    console.log('Error in get getSystemConfig ', ex.message);
  }
  return getSystemConfigResponse;
}

export async function updateRestriction(data, payload) {
  let UpdateResponse = [];
  const headers = {
    'Content-Type': 'application/json',
  };
  try {
    const url =
      window.env.REACT_APP_BACKEND_URL +
      `/buow_api/get-document/restrict?documentId=${data.documentId ? data.documentId : ''}&pageId=${data.pageId ? data.pageId : ''}&isRestricted=${data.isRestricted}`;

    const response = await axios.put(url, payload, { headers });

    UpdateResponse = response;
  } catch (ex) {
    console.error('Error in updateNextInBasket()', ex.message);
    UpdateResponse.error = ex.response.data;
  }
  return UpdateResponse;
}

export async function getRuleNames(data) {
  let workQueueFilterResponse = [];
  try {
    const url = `/buow_api/ruledefinition/getallrules/search?contextid=${data.contextId}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        workQueueFilterResponse = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }
  return workQueueFilterResponse;
}
export async function deleteCard(data) {
  let DeleteResponse = [];
  const headers = {
    'Content-Type': 'application/json',
  };
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/rulelogs/logId/${data.logId}`;

    const response = await axios.delete(url, { headers }, data);

    DeleteResponse = response;
  } catch (ex) {
    console.error('Error in updateNextInBasket()', ex.message);
    DeleteResponse.error = ex.response.data;
  }
  return DeleteResponse;
}

export async function searchRedactionReasonData(data) {
  let redactionReasonResponse = [];
  let text = encodeURIComponent(data.text);
  try {
    let url = `${window.env.REACT_APP_BACKEND_URL}/buow_api/redactionreason?contextId=${data.contextId}&search=${text}`;

    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        redactionReasonResponse = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }
  return redactionReasonResponse;
}

export async function searchRedactionReferenceData(data) {
  let redactionReferenceResponse = [];
  let text = encodeURIComponent(data.text);
  try {
    let url = `${window.env.REACT_APP_BACKEND_URL}/buow_api/redactionreference/reference?contextId=${data.contextId}&search=${text}`;

    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        redactionReferenceResponse = response;
      });
  } catch (ex) {
    console.log('Error in get messages ', ex.message);
  }
  return redactionReferenceResponse;
}

export async function submitRegisCorrection({ inBasketId, correctedValues }) {
  try {
    const url = `${window.env.REACT_APP_BACKEND_URL}/buow_api/inbasket/${inBasketId}/resubmit`;
    const response = await axios.post(
      url,
      { correctedMetadata: correctedValues || {} },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response;
  } catch (ex) {
    console.log('Error in submitRegisCorrection ', ex.message);
    return ex.response ?? null;
  }
}
